import { Link } from "react-router-dom";
import { useSiteContent } from "../../lib/api";

export function BookingCTA({ children, className = "", testId = "booking-cta", fallbackTo = "/contact" }) {
  const content = useSiteContent();
  const bookingUrl = content?.booking_url || "";

  if (!bookingUrl) {
    return <Link to={fallbackTo} data-testid={testId} className={className}>{children}</Link>;
  }
  // Open the ServiceM8 booking form in a new tab so enquiries land directly in ServiceM8.
  return (
    <a href={bookingUrl} target="_blank" rel="noopener noreferrer" data-testid={testId} className={className}>
      {children}
    </a>
  );
}
